import { inject } from '@angular/core';
import { KeycloakTokenRefresher } from '@app/shared/auth/keycloak/keycloak-token-refresher.service';
import { ILogoutService } from '@app/shared/auth/logout/logout-service';
import Keycloak from 'keycloak-js';

export class LogoutService implements ILogoutService {
  private readonly keycloak = inject(Keycloak);
  private readonly keycloakTokenRefresher = inject(KeycloakTokenRefresher);

  logout(): void {
    this.keycloakTokenRefresher.stop();
    this.keycloak.logout();
  }
}
